import DocumentsFunnel from './styled';

export default DocumentsFunnel;
